var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"n-panel-box"}},_vm._l((_vm.list),function(item){return _c(item.name,{key:item.id,tag:"compoment",attrs:{"id":item.id,"extra":item.extra}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }